import { Routes } from '@angular/router';

export const trialConsultationRoutes: Routes = [
  {
    path: 'trial-consultation/:id',
    loadComponent: () =>
      import('./pages/trial-consultation/trial-consultation.component').then((x) => x.TrialConsultationComponent),
    title: 'Trial Consultation',
  },
];
